<epay-page-content [pagetitle]="pagetitle">
  <!-- TODO: user flow for employer / ncp; existing / new user; ACH / credit -->
  <div class="page-content-main max-w max-gxs t-alignC" id="page-content-main">
    <div class="box-panel ie-note mb-5" *ngIf="isIE">
      <div class="small-note-block alert-note">
        <p class="c-red1">
          {{ieMessage}}
        </p>
      </div>
    </div>
  </div>
  <div class="page-content-main max-w max-gs mb-4 t-alignC">
    <div class="message-panel" *ngIf="message1">
      <div class="box-panel">
        <p class="c-red1b">{{message1}}</p>
        <p class="c-red1b">{{message2}}</p>
        <p class="c-red1b">{{message3}}</p>
      </div>
    </div>
  </div>

  <div class="page-content-main max-w max-gxs t-alignC" id="page-content-main">
    <div class="box-panel translucent-panel access-panel mb-5">
      <p class="mb-2">This North Dakota Internet Payment website is dedicated to providing quality
        customer service to noncustodial parents who need assistance with the child support payment
        process.</p>
      <!-- Start here -->
      <div class="access-links m--pa4 mb-2">
        <div class="mb-3 t-alignC">
          <a class="db btn-link mt-3" [routerLink]="['/ncp/creditcard']">Credit Card Payment</a>
          <div style="margin-top: 1rem; text-align: center;">
            <span style="font-size: 0.8rem; padding: 0.2rem;">
              Make a child support payment using a credit card by phone at
            </span>
            <div style="font-weight: bold; font-size: 0.9rem;">
              1-877-251-9843
            </div>
          </div>
        </div>
      </div>

      <div class="small-note-block xs-note">
        <p>Note: This website requires that cookies be enabled in your
          browser. By accessing this site, you agree to have cookies stored on your computer. You can read more about
          how this site uses cookies in our <a [routerLink]="['/privacypolicy']">Privacy Policy</a>
        </p>
      </div>
    </div>
  </div>
  <!-- <div class="page-content-main max-w max-gs t-alignC">
    <div class="message-panel" *ngIf="message1">
      <div class="box-panel">
        <p class="c-red1b">{{message1}}</p>
        <p class="c-red1b">{{message2}}</p>
        <p class="c-red1b">{{message3}}</p>
      </div>
    </div>
  </div> -->
</epay-page-content>
